export enum PREFERENCES_LOCAL {
    themeMode = 'THEME_MODE',
    firstDayOfWeek = 'FIRST_DAY_OF_WEEK',
    language = 'LANGUAGE'
}